import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { ref: "tableRootRef" }
const _hoisted_2 = { class: "btn-container clearfix" }
const _hoisted_3 = { class: "left-opt fl" }
const _hoisted_4 = { class: "rigth-opt fr" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ZPreview = _resolveComponent("ZPreview")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_FromField = _resolveComponent("FromField")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.canAdd)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "filter-item",
              type: "primary",
              size: _ctx.t('table.btnSize'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCommand('add')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
              ]),
              _: 1
            }, 8, ["size"])), [
              [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
            ])
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "left-buttons")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "right-buttons"),
        (_ctx.canRefresh)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "svg-icon cursor mr-10",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCommand('refresh')))
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.canChangeColumn)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "svg-icon cursor",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSetColumnVisible && _ctx.handleSetColumnVisible(...args)))
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "elTableRef",
      data: _ctx.dataList,
      border: "",
      fit: "",
      stripe: _ctx.isStripe,
      "row-key": "id",
      style: {"width":"100%"},
      "max-height": _ctx.tableMaxHegiht,
      "highlight-current-row": _ctx.highlightCurrentRow,
      "tree-props": { children: 'children', hasChildren: 'hasChildren' },
      "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
      "row-class-name": _ctx.tableRowClassName,
      "summary-method": _ctx.getSummaries,
      "show-summary": _ctx.showSummary,
      "span-method": _ctx.objectSpanMethod,
      onRowClick: _ctx.handleRowChange,
      onSelectionChange: _ctx.handleSelectionChange,
      onHeaderDragend: _ctx.handleHeaderDragend
    }, {
      default: _withCtx(() => [
        (_ctx.showSelection)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection",
              width: _ctx.showSummary ? 60 : 45,
              fixed: "left"
            }, null, 8, ["width"]))
          : _createCommentVNode("", true),
        (_ctx.showIndex)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              type: "index",
              width: 60,
              label: "序列号"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnData, (column, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            "min-width": _ctx.customColumnWidth(column),
            width: column.width || '',
            key: `${_ctx.getColIdentity(column)}_${index}`,
            prop: JSON.stringify(column),
            label: column.fieldName,
            "show-overflow-tooltip": "",
            align: column.textAlign || 'left'
          }, {
            default: _withCtx(({ row, $index }) => [
              (!(row.editable ?? row.isEidt))
                ? _renderSlot(_ctx.$slots, column.fieldKey, _mergeProps({
                    key: 0,
                    ref_for: true
                  }, { row, $index }), () => [
                    (column.convert)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (column.html)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                innerHTML: _ctx.getConvertValue(column, row, $index, index)
                              }, null, 8, _hoisted_5))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getConvertValue(column, row, $index, index)), 1))
                        ], 64))
                      : (column.formatter || column.formatType || column.isMoney)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.getFormattedCell(column, row, $index)), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (column.componentType === 'el-upload')
                              ? (_openBlock(), _createBlock(_component_ZPreview, {
                                  key: 0,
                                  authSrc: row[column.fieldKey],
                                  width: 'auto',
                                  height: '.533333rem',
                                  isEdit: false
                                }, null, 8, ["authSrc"]))
                              : (column.componentType === 'el-iconfont')
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 1,
                                    class: _normalizeClass(["iconfont", _ctx.getColumnValue(column, row)])
                                  }, null, 2))
                                : (column.componentType === 'el-array')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(column.formatValue && column.formatValue(row)), 1))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 3,
                                      class: _normalizeClass({ 'cell-red': _ctx.isChanged(column, row) })
                                    }, [
                                      (_ctx.isChanged(column, row))
                                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                            key: 0,
                                            effect: "dark",
                                            content: _ctx.getDiffTip(column, row),
                                            placement: "top-start"
                                          }, {
                                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                              _createElementVNode("i", { class: "iconfont icon-tubiao-40 cell-blue" }, null, -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["content"]))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(_ctx.getColumnValue(column, row)), 1)
                                    ], 2))
                          ], 64))
                  ])
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList((row.editForm ?? row.eidtForm), (fields, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      (column.fieldKey === fields.fieldKey)
                        ? (_openBlock(), _createBlock(_component_FromField, {
                            key: 0,
                            fields: fields,
                            "team-change": _ctx.handleEditChange(fields),
                            id: row.id || 0
                          }, null, 8, ["fields", "team-change", "id"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
            ]),
            _: 2
          }, 1032, ["min-width", "width", "prop", "label", "align"]))
        }), 128)),
        (_ctx.canCommand)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              label: "操作",
              align: "center",
              "min-width": _ctx.handleDefaultWidth,
              fixed: "right"
            }, {
              default: _withCtx(({ row, $index }) => [
                _renderSlot(_ctx.$slots, "operation-action", _normalizeProps(_guardReactiveProps({ row, $index })))
              ]),
              _: 3
            }, 8, ["min-width"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["data", "stripe", "max-height", "highlight-current-row", "row-class-name", "summary-method", "show-summary", "span-method", "onRowClick", "onSelectionChange", "onHeaderDragend"])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.isShowPagination)
      ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          class: "mt-20",
          total: _ctx.ttotal,
          currentPage: _ctx.tpage,
          "page-size": _ctx.tsize,
          "page-sizes": _ctx.pageSizes,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange,
          layout: "total, sizes, prev, pager, next"
        }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.setColumnVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.setColumnVisible) = $event)),
      title: "选择列表显示数据",
      width: "600px",
      "append-to-body": "",
      "close-on-click-modal": false,
      "before-close": _ctx.handleSetColumnClose,
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, { onClick: _ctx.handleResetColumn }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("恢复默认", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _ctx.handleSetColumnClose,
            type: "danger"
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleSetColumn
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_checkbox_group, {
          modelValue: _ctx.columnCheckList,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.columnCheckList) = $event)),
          class: "columnSet"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_draggable, {
              list: _ctx.tabelField,
              itemKey: _ctx.getColIdentity,
              "ghost-class": "ghost",
              "chosen-class": "chosenClass",
              animation: "300",
              onEnd: _ctx.handleDraggleEnd
            }, {
              item: _withCtx(({ element }) => [
                _createVNode(_component_el_checkbox, {
                  value: _ctx.getColIdentity(element),
                  label: element.fieldName
                }, null, 8, ["value", "label"])
              ]),
              _: 1
            }, 8, ["list", "itemKey", "onEnd"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 512))
}